import { render, staticRenderFns } from "./page-privacy-policy.vue?vue&type=template&id=7a1b3772"
import script from "./page-privacy-policy.js?vue&type=script&lang=js&external"
export * from "./page-privacy-policy.js?vue&type=script&lang=js&external"
import style0 from "./page-privacy-policy.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports